
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { TextConfigurationState } from './types-store';
import { reducer as codeDescriptionListReducer, INITIAL_STATE as codeDescriptionListState } from './list/code/reducers';
import { textConfigurationListReducer, textConfigurationListState } from './list/text/reducers';
import { reducer as textConfigurationFormReducer, INITIAL_STATE as textConfigurationFormState } from './form/reducers';

export const INITIAL_STATE: TextConfigurationState = {
  listText: textConfigurationListState,
  listCodeDescription: codeDescriptionListState,
  form: textConfigurationFormState
};

export const reducer: Reducer<TextConfigurationState> = withOptionsReducer(
  STATE.textConfiguration,
  mergeReducers({
    listText: textConfigurationListReducer,
    listCodeDescription: codeDescriptionListReducer,
    form: textConfigurationFormReducer
  })
);
